// extracted by css-extract-rspack-plugin
export default {"list":"axWMtOT___list","item":"LCKuqpW___item"};